import { render, staticRenderFns } from "./RecentAssessmentsTable.vue?vue&type=template&id=73940264&scoped=true"
import script from "./RecentAssessmentsTable.vue?vue&type=script&lang=ts"
export * from "./RecentAssessmentsTable.vue?vue&type=script&lang=ts"
import style0 from "./RecentAssessmentsTable.vue?vue&type=style&index=0&id=73940264&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73940264",
  null
  
)

export default component.exports